const ROUNDING_STEP = 250;
const HIGH_VALUE_EDC = 80000;
const BACK_END_CAP = 10000;
const HIGH_VALUE_BACK_END_CAP = 15000;
const ADVANCE_EDC_SHARE = 0.3;
const MAX_LINE_5_LTV = 1.6;

interface IBackAddsEstimateParams {
  /** Line 3 Policy, as a percent. */
  policy?: number | null;
  line3?: number | null;
  edc?: number | null;
  advance?: number | null;
  maxBackEnd?: number | null;
}

const isNumber = (value?: number | null): value is number => typeof value === 'number' && !Number.isNaN(value);

const floorToStep = (value: number) => Math.floor(value / ROUNDING_STEP) * ROUNDING_STEP;

/** "Ally Back End Calculator.xlsx" (SWA-8036), capped at the lender's Back-End limit. */
export const getBackAddsEstimate = ({
  policy,
  line3,
  edc,
  advance,
  maxBackEnd,
}: IBackAddsEstimateParams): number | null => {
  if (!isNumber(policy) || !isNumber(line3) || !isNumber(edc) || !isNumber(advance)) {
    return null;
  }

  const cap = edc > HIGH_VALUE_EDC ? HIGH_VALUE_BACK_END_CAP : BACK_END_CAP;
  const beforeAdvance = Math.min(cap, Math.max(0, floorToStep((edc * policy) / 100 - line3)));
  const applicableAdvance = Math.max(
    0,
    floorToStep(Math.min(advance, cap, edc * ADVANCE_EDC_SHARE - ROUNDING_STEP - beforeAdvance)),
  );
  const limit = isNumber(maxBackEnd) ? maxBackEnd : Infinity;

  return Math.max(0, Math.min(beforeAdvance + applicableAdvance, cap, edc * MAX_LINE_5_LTV - line3, limit));
};
